
document.addEventListener("DOMContentLoaded", () => {

    let modalVideoButtons = document.getElementsByClassName('js-modal-btn');

    for (let i = 0; i < modalVideoButtons.length; i++) {

        let options = {};

        if (modalVideoButtons[i].dataset.ratio !== undefined) {
            options.ratio = modalVideoButtons[i].dataset.ratio;
        }

        if (modalVideoButtons[i].dataset.channel !== undefined) {
            options.channel = modalVideoButtons[i].dataset.channel;
        }

        new ModalVideo('#' + modalVideoButtons[i].id, options);

        modalVideoButtons[i].addEventListener("click", function () {
            window.dispatchEvent(new Event('resize'));
        });
    }

});
